import { createGlobalStyle, css, FlattenSimpleInterpolation } from 'styled-components';

export const SitePerformanceChartTooltipGlobalStyles = createGlobalStyle`
  ${({ theme: { kcc } }): FlattenSimpleInterpolation => css`
    .site-performance-chart__tooltip-positioner {
      position: absolute;
      left: 0;
      top: 0;
      pointer-events: none;
      opacity: 0;
      visibility: hidden;
      transition: opacity 0.3s ease, visibility 0.3s ease;
      will-change: transform, opacity;
    }

    .site-performance-chart__tooltip-positioner.site-performance-chart__tooltip--visible {
      opacity: 1;
      visibility: visible;
    }

    .site-performance-chart__tooltip {
      min-width: 250px;
      background-color: ${kcc.colors.BLACK};
      color: ${kcc.colors.WHITE};
      padding: ${kcc.spacing.SM};
      border: ${kcc.lineWidth.BORDER}px solid ${kcc.colors.GRAY_100};
      box-shadow: 0 0 30px rgba(0, 0, 0, 0.03);
      font-family: ${kcc.typography.FONT_FAMILY};
      font-size: ${kcc.typography.FONT_SIZE.SM}px;
      line-height: ${kcc.typography.LINE_HEIGHT.BASE};
    }

    .site-performance-chart__tooltip-title {
      font-weight: ${kcc.typography.FONT_WEIGHT.EXTRA_BOLD};
      margin: 0;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-word;
    }

    .site-performance-chart__tooltip-subtitle {
      font-weight: ${kcc.typography.FONT_WEIGHT.REGULAR};
      margin: 0;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-word;
    }

    .site-performance-chart__tooltip-item-square-icon {
      height: ${kcc.spacing.XS};
      width: ${kcc.spacing.XS};
      flex-shrink: 0;
    }

    .site-performance-chart__tooltip-item-seriesLabel {
      margin: 0;
      font-weight: ${kcc.typography.FONT_WEIGHT.REGULAR};
    }

    .site-performance-chart__tooltip-item-hours,
    .site-performance-chart__tooltip-item-percent {
      margin: 0;
      font-weight: ${kcc.typography.FONT_WEIGHT.EXTRA_BOLD};
    }

    .site-performance-chart__tooltip-divider {
      margin: 0;
      border-color: ${kcc.colors.GRAY_900};
      height: ${kcc.lineWidth.BORDER}px;
    }
  `}
`;
